export const lightModeLogo = '/images/lightModeLogo.webp';
export const darkModeLogo = '/images/darkModeLogo.webp';
export const pdfLogo = '/images/pdf.png';
export const ggIconOnly = '/images/ggIconOnly.png';
